export default __webpack_public_path__ + "static/media/15.ba440aa1.png";